<template>
  <div>
    <a-spin :spinning="loading">
      <a-form-model :model="iPersona" :rules="formRules" @submit="guardarInformacionBancaria"
                    @submit.native.prevent ref="datosPersonalesForm">
        <a-col :span="24">
          <a-card>
            <a-row :gutter="[16,16]">

              <a-col v-bind="colSpan">
                <a-form-model-item :label="$t('Nom. del banco')" prop="name_bank" has-feedback>
                  <a-input style="width: 100%"
                           class="ant-uppercase"
                           v-model="iPersona.name_bank"></a-input>
                </a-form-model-item>
              </a-col>

              <a-col v-bind="colSpan">
                <a-form-model-item :label="$t('Núm. de cuenta')" prop="account_number" has-feedback>
                  <a-input style="width: 100%"
                           class="ant-uppercase"
                           v-model="iPersona.account_number"></a-input>
                </a-form-model-item>
              </a-col>

              <a-col v-bind="colSpan">
                <a-form-model-item :label="$t('Cód. ACH o SWIFT')" prop="code_bank" has-feedback>
                  <a-input style="width: 100%"
                           class="ant-uppercase"
                           v-model="iPersona.code_bank"></a-input>
                </a-form-model-item>
              </a-col>

              <a-col v-bind="colSpan">
                <a-form-model-item :label="$t('Dir. banco')" prop="address_bank" has-feedback>
                  <a-input style="width: 100%"
                           class="ant-uppercase"
                           v-model="iPersona.address_bank"></a-input>
                </a-form-model-item>
              </a-col>

              <a-col v-bind="colSpan">
                <a-form-model-item :label="$t('País del banco')" prop="bank_country" has-feedback>
                  <form-model-dropdown style="width: 100%"
                                       endpoint="hierarchy_lookup"
                                       v-model="iPersona.bank_country"
                                       :selectedObj.sync="dropdown.country_expedition_selected"
                                       :customSlots="['suffixIcon']"
                                       :params="request.pais"

                  >
                    <template slot="suffixIcon">
                      <img style="max-width: 20px"
                           :src="flags[dropdown.country_expedition_selected.equivalency]"
                           alt=""
                           v-if="dropdown.country_expedition_selected && dropdown.country_expedition_selected.equivalency">
                    </template>
                  </form-model-dropdown>
                </a-form-model-item>
              </a-col>

              <a-col v-bind="colSpan">
                <a-form-model-item :label="$t('Ciu. banco')" prop="bank_city" has-feedback>
                  <form-model-lookup style="width: 100%"
                                     endpoint="hierarchy_lookup"
                                     v-model="iPersona.bank_city"
                                     :params="request.ciudad"
                  >
                  </form-model-lookup>
                </a-form-model-item>
              </a-col>

              <a-col v-bind="colSpan">
                <a-form-model-item :label="$t('Nom. beneficiario')" prop="payee_beneficiary_name" has-feedback>
                  <a-input style="width: 100%"
                           class="ant-uppercase"
                           v-model="iPersona.payee_beneficiary_name"></a-input>
                </a-form-model-item>
              </a-col>

              <a-col v-bind="colSpan">
                <a-form-model-item :label="$t('Dir. beneficiario')" prop="payee_address" has-feedback>
                  <a-input style="width: 100%"
                           class="ant-uppercase"
                           v-model="iPersona.payee_address"></a-input>
                </a-form-model-item>
              </a-col>

              <a-col v-bind="colSpan">
                <a-form-model-item :label="$t('País del ben.')" prop="payee_country" has-feedback>
                  <form-model-dropdown style="width: 100%"
                                       endpoint="hierarchy_lookup"
                                       v-model="iPersona.payee_country"
                                       :selectedObj.sync="dropdown.country_expedition_selected2"
                                       :customSlots="['suffixIcon']"
                                       :params="request.pais"

                  >
                    <template slot="suffixIcon">
                      <img style="max-width: 20px"
                           :src="flags[dropdown.country_expedition_selected2.equivalency]"
                           alt=""
                           v-if="dropdown.country_expedition_selected2 && dropdown.country_expedition_selected2.equivalency">
                    </template>
                  </form-model-dropdown>
                </a-form-model-item>
              </a-col>

              <a-col v-bind="colSpan">
                <a-form-model-item :label="$t('Ciu. beneficiario')" prop="payee_city" has-feedback>
                  <form-model-lookup style="width: 100%"
                                     endpoint="hierarchy_lookup"
                                     v-model="iPersona.payee_city"
                                     :params="request.ciudad"
                  >
                  </form-model-lookup>
                </a-form-model-item>
              </a-col>

              <a-col v-bind="colSpan">
                <a-form-model-item :label="$t('Nom. banco interm.')" prop="intermediary_bank" has-feedback>
                  <a-input style="width: 100%"
                           class="ant-uppercase"
                           v-model="iPersona.intermediary_bank"></a-input>
                </a-form-model-item>
              </a-col>

              <a-col v-bind="colSpan">
                <a-form-model-item :label="$t('Cod. banco SWIFT.')" prop="inter_code_number" has-feedback>
                  <a-input style="width: 100%"
                           class="ant-uppercase"
                           v-model="iPersona.inter_code_number"></a-input>
                </a-form-model-item>
              </a-col>

              <a-col v-bind="colSpan">
                <a-form-model-item :label="$t('Dir. banco interm.')" prop="inter_bank_address" has-feedback>
                  <a-input style="width: 100%"
                           class="ant-uppercase"
                           v-model="iPersona.inter_bank_address"></a-input>
                </a-form-model-item>
              </a-col>

              <a-col v-bind="colSpan">
                <a-form-model-item :label="$t('País banco int.')" prop="inter_country" has-feedback>
                  <form-model-dropdown style="width: 100%"
                                       endpoint="hierarchy_lookup"
                                       v-model="iPersona.inter_country"
                                       :selectedObj.sync="dropdown.country_expedition_selected3"
                                       :customSlots="['suffixIcon']"
                                       :params="request.pais"

                  >
                    <template slot="suffixIcon">
                      <img style="max-width: 20px"
                           :src="flags[dropdown.country_expedition_selected3.equivalency]"
                           alt=""
                           v-if="dropdown.country_expedition_selected3 && dropdown.country_expedition_selected3.equivalency">
                    </template>
                  </form-model-dropdown>
                </a-form-model-item>
              </a-col>

              <a-col v-bind="colSpan">
                <a-form-model-item :label="$t('Ciu. banco int.')" prop="inter_city" has-feedback>
                  <form-model-lookup style="width: 100%"
                                     endpoint="hierarchy_lookup"
                                     v-model="iPersona.inter_city"
                                     :params="request.ciudad"
                  >
                  </form-model-lookup>
                </a-form-model-item>
              </a-col>

              <a-col v-bind="colSpan">
                <a-form-model-item :label="$t('Tipo cuenta')" prop="account_type" has-feedback>
                  <form-model-dropdown style="width: 100%"
                                       endpoint="hierarchy_lookup"
                                       v-model="iPersona.account_type"
                                       :customSlots="['suffixIcon']"
                                       :params="request.tipo_cuenta"

                  >
                  </form-model-dropdown>
                </a-form-model-item>
              </a-col>

              <a-col v-bind="colSpan">
                <a-form-model-item :label="$t('Núm. cuenta espc.')" prop="especial_account_number" has-feedback>
                  <a-input style="width: 100%"
                           class="ant-uppercase"
                           v-model="iPersona.especial_account_number"></a-input>
                </a-form-model-item>
              </a-col>


              <a-col v-bind="colSpan">
                <a-form-model-item :label="$t('Nomb. especial')" prop="especial_name" has-feedback>
                  <a-input style="width: 100%"
                           class="ant-uppercase"
                           v-model="iPersona.especial_name"></a-input>
                </a-form-model-item>
              </a-col>

            </a-row>
            <a-divider type="horizontal"/>
            <a-row style="text-align: right" :bodyStyle="{padding: '12px 24px'}">
              <a-button v-if="!$userIsInrol('Query')"
                type="primary"
                html-type="submit">
                Guardar datos personales
              </a-button>
            </a-row>
          </a-card>
        </a-col>
      </a-form-model>

    </a-spin>
  </div>
</template>
<script>
  import JsUtils from '@/util/JsUtils'
  import Mensajes from 'CustomModules/GlobalBPOCore/Util/Mensajes'
  import HttpUtil from '@/util/HttpUtil'
  import FLAGS from 'CustomModules/GlobalBPOCore/Util/FlagsUtil'

  export default {
    data () {
      return {
        flags: FLAGS,
        request: {
          tipo_cuenta: {
            h_lookup_type: 'TIPO_CUENTA'
          },
          pais: {
            h_lookup_type: 'PAISES_HV'
          },
          ciudad: {
            h_lookup_type: 'CIUDADES_HV'
          }
        },
        dropdown: {
          country_expedition_selected: {},
          country_expedition_selected2: {},
          country_expedition_selected3: {}
        },
        iPersona: {},
        formRules: {},
        loading: false,
        colSpan: {
          xs: 24,
          md: 8
        }
      }
    },
    props: ['persona'],
    methods: {
      guardarInformacionBancaria () {
        if (this.loading) return
        this.$refs.datosPersonalesForm.validate(valid => {
          if (valid) {
            this.loading = true
            let request = {...this.iPersona, id_person: this.persona}

            this.httpClient.getInstance().post('biodata/guardar_person_interbank', request)
              .then(() => {
                Mensajes.success('Correcto', 'Datos guardados correctamente')
              })
              .catch(() => {
                Mensajes.error('Error', 'No fue posible guardar la información, contacte al administrador.')
              })
              .then(() => {
                this.loading = false
              })
          }
        })
      },
      loadData () {
        if (JsUtils.isEmpty(this.persona)) {
          return
        }
        this.loading = true
        this.httpClient.getInstance().get('biodata/consultar_person_interbank/' + this.persona)
          .then(response => {
            this.iPersona = {...response.data}
          })
          .catch(() => {
            Mensajes.error('Error', 'No fue posible consultar los datos personales, contacte al administrador.')
          })
          .then(() => {
            this.loading = false
          })
      },
      initFormRules () {
        this.formRules = {
          name_bank: [{required: true, message: 'Valor requerido'}],
          account_number: [{required: true, message: 'Valor requerido'}],
          code_bank: [{required: false}],
          address_bank: [{required: true, message: 'Valor requerido'}],
          bank_country: [{required: false}],
          bank_city: [{required: false}],
          payee_beneficiary_name: [{required: false}],
          payee_address: [{required: false}],
          payee_country: [{required: false}],
          payee_city: [{required: false}],
          intermediary_bank: [{required: false}],
          inter_code_number: [{required: true, message: 'Valor requerido'}],
          account_type: [{required: true, message: 'Valor requerido'}],
          inter_bank_address: [{required: false}],
          inter_country: [{required: false}],
          inter_city: [{required: false}],
          especial_account_number: [{required: false}],
          especial_name: [{required: false}]
        }
      }
    },
    mounted () {
      this.httpClient = new HttpUtil()
      this.loadData()
      this.initFormRules()
    }
  }
</script>



// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Biodata/BiodataInformacionBancariaInternacional.vue